import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-org-user-companies',
  templateUrl: './org-user-companies.component.html',
  styleUrls: ['./org-user-companies.component.scss']
})
export class OrgUserCompaniesComponent implements OnInit {
    @Input('companies') companies: any[] = [];
    displayedColumns = ['name', 'currentRole', 'newRole'];
    
    constructor() { }

    ngOnInit(): void {
    }

}
